import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-id", "data-item-id", "data-artnr", "data-wban"]
const _hoisted_2 = { class: "product-box-campaign__segment-image" }
const _hoisted_3 = { class: "product-box-campaign__flags" }
const _hoisted_4 = { class: "product-box-campaign__image-background-wrapper" }
const _hoisted_5 = { class: "lazy-load-image product-box-campaign__image" }
const _hoisted_6 = { class: "product-box-campaign__segment-box" }
const _hoisted_7 = { class: "product-box-campaign__segment-center" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "product-box-campaign__header-text product-box__header-text" }
const _hoisted_10 = { class: "product-box-campaign__header-top" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = {
  key: 0,
  class: "product-box-campaign__quickfacts-wrapper"
}
const _hoisted_14 = { class: "product-box-campaign__long-description-wrapper" }
const _hoisted_15 = { class: "product-box-campaign__quote-block" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 3,
  class: "product-box-campaign__quote"
}
const _hoisted_20 = { class: "product-box-campaign__quote-text-wrapper" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 0,
  class: "product-box-campaign__quote-image-wrapper"
}
const _hoisted_23 = {
  key: 0,
  class: "product-box-campaign__segment-conversion"
}
const _hoisted_24 = { class: "product-box-campaign__price-wrapper product-box-campaign__price-wrapper--no-price" }
const _hoisted_25 = { class: "product-box__buttons" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "product-box-campaign__segment-conversion" }
const _hoisted_28 = { class: "product-box-campaign__segment-conversion-price" }
const _hoisted_29 = { class: "product-box-campaign__bottle-amount" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "product-box-campaign__segment-conversion-buttons" }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flag_savings = _resolveComponent("flag-savings")!
  const _component_flags = _resolveComponent("flags")!
  const _component_image_element = _resolveComponent("image-element")!
  const _component_quickfacts = _resolveComponent("quickfacts")!
  const _component_lazy_load = _resolveComponent("lazy-load")!
  const _component_availability_info = _resolveComponent("availability-info")!
  const _component_price_info = _resolveComponent("price-info")!
  const _component_product_qty_and_cart_btn = _resolveComponent("product-qty-and-cart-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-box-campaign", {
      'product-box-campaign--in-basket': _ctx.productBoxData.inBasket,
      'product-box-campaign--error': _ctx.state === 'error',
      'product-box-campaign--red-wine': $options.wineType === 'red',
      'product-box-campaign--rose-wine': $options.wineType === 'rose',
      'product-box-campaign--white-wine': $options.wineType === 'white',
      'product-box-campaign--homogen': $options.setType === 'homogen',
      'product-box-campaign--heterogen': $options.setType === 'heterogen',
      'product-box-campaign--has-quote': _ctx.productBoxData.flags.quote && _ctx.productBoxData.flags.quote.text,
      'product-box-campaign--has-quickfacts': $options.hasQuickfacts,
      'product-box-campaign--personalization': _ctx.productBoxData.personalPreferenceMessageKey,
      'product-box-campaign--no-quote': !$data.initialProductBoxData.flags.quote
    }]),
    "data-id": _ctx.productBoxData.id,
    "data-item-id": _ctx.productBoxData.itemId,
    "data-artnr": _ctx.productBoxData.trackingData.artNr,
    "data-wban": _ctx.productBoxData.trackingData.wban
  }, [
    (_ctx.productBoxData.price.savedPercentage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["product-box-campaign__savings", {
        'flag-savings--bigger': $options.savedAmountBigger
      }])
        }, [
          _createVNode(_component_flag_savings, {
            "second-text-key": 'flags.savings.text.savedAmount',
            "saved-percentage": $options.savedPercentage,
            "saved-amount": $options.savedAmount
          }, null, 8 /* PROPS */, ["saved-percentage", "saved-amount"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _cache[16] || (_cache[16] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_flags, {
          flags: _ctx.productBoxData.flags,
          limit: 2,
          "award-limit": 2,
          "white-list": ['new', 'award', 'bio']
        }, null, 8 /* PROPS */, ["flags"])
      ]),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productBoxData.linked ? 'a' : 'div'), {
          href: _ctx.productBoxData.linked ? _ctx.productBoxData.url : null,
          class: "product-box-campaign__image-wrapper"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (
                _setBlockTracking(-1, true),
                (_cache[0] = _createVNode(_component_image_element, {
                  "img-class": "lazy-load-image__image",
                  src: $options.imgSrc,
                  title: _ctx.productBoxData.images[0].title,
                  alt: _ctx.productBoxData.images[0].alt,
                  webp: true
                }, null, 8 /* PROPS */, ["src", "title", "alt"])).cacheIndex = 0,
                _setBlockTracking(1),
                _cache[0]
              )
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"]))
      ])
    ]),
    _cache[17] || (_cache[17] = _createTextVNode()),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          class: "product-box-campaign__header product-box__segment-header",
          href: _ctx.productBoxData.url
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.productBoxData.description1)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "product-box-campaign__set-name",
                    innerHTML: _ctx.productBoxData.description1
                  }, null, 8 /* PROPS */, _hoisted_11))
                : _createCommentVNode("v-if", true),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _createElementVNode("span", {
                class: "product-box-campaign__set-type",
                textContent: _toDisplayString($options.setTypeName)
              }, null, 8 /* PROPS */, _hoisted_12)
            ]),
            _cache[3] || (_cache[3] = _createTextVNode()),
            ($options.hasQuickfacts)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_quickfacts, {
                    class: "product-box-campaign__quickfacts",
                    quickfacts: $options.quickfactList,
                    "use-links": false
                  }, null, 8 /* PROPS */, ["quickfacts"])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 8 /* PROPS */, _hoisted_8),
        _cache[8] || (_cache[8] = _createTextVNode()),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_ctx.productBoxData.shortDescription)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "product-box-campaign__title",
                  innerHTML: _ctx.productBoxData.shortDescription
                }, null, 8 /* PROPS */, _hoisted_16))
              : _createCommentVNode("v-if", true),
            _cache[4] || (_cache[4] = _createTextVNode()),
            (!$data.initialProductBoxData.flags.quote)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "product-box-campaign__long-description",
                  innerHTML: $options.descriptionExcerpt
                }, null, 8 /* PROPS */, _hoisted_17))
              : _createCommentVNode("v-if", true),
            _cache[5] || (_cache[5] = _createTextVNode()),
            ($data.initialProductBoxData.flags.quote)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "product-box-campaign__quote-text",
                  innerHTML: $data.initialProductBoxData.flags.quote.text
                }, null, 8 /* PROPS */, _hoisted_18))
              : _createCommentVNode("v-if", true),
            _cache[6] || (_cache[6] = _createTextVNode()),
            ($data.initialProductBoxData.flags.quote)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    ($data.initialProductBoxData.flags.quote.author)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "product-box-campaign__quote-author",
                          innerHTML: $data.initialProductBoxData.flags.quote.author
                        }, null, 8 /* PROPS */, _hoisted_21))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _cache[7] || (_cache[7] = _createTextVNode()),
          ($data.initialProductBoxData.flags.quote)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                ($data.initialProductBoxData.flags.quote.image)
                  ? (_openBlock(), _createBlock(_component_lazy_load, {
                      key: 0,
                      class: "product-box-campaign__quote-image"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_image_element, {
                          "img-class": "lazy-load-image__image",
                          src: [$data.initialProductBoxData.flags.quote.image],
                          alt: $data.initialProductBoxData.flags.quote.author,
                          webp: true
                        }, null, 8 /* PROPS */, ["src", "alt"])
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _cache[14] || (_cache[14] = _createTextVNode()),
      (_ctx.productBoxData.zeroPriceItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("a", {
                  class: "product-box__status product-box__status--unavailable",
                  href: _ctx.productBoxData.url
                }, _toDisplayString(_ctx.$t('availability.no-price')), 9 /* TEXT, PROPS */, _hoisted_26)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _cache[15] || (_cache[15] = _createTextVNode()),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, [
            (_ctx.productBoxData.numberOfBottlesInSet && _ctx.productBoxData.numberOfBottlesInSet >= 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('volumeUnit.numberOfBottlesInSet', [_ctx.productBoxData.numberOfBottlesInSet])), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _cache[9] || (_cache[9] = _createTextVNode()),
          (_ctx.showAvailability)
            ? (_openBlock(), _createBlock(_component_availability_info, {
                key: 0,
                class: "product-box-campaign__availability product-box__availability",
                availability: _ctx.productBoxData.availability
              }, null, 8 /* PROPS */, ["availability"]))
            : _createCommentVNode("v-if", true),
          _cache[10] || (_cache[10] = _createTextVNode()),
          (_ctx.productBoxData.price)
            ? (_openBlock(), _createBlock(_component_price_info, {
                key: 1,
                class: "product-box-campaign__price product-box__price",
                value: _ctx.productBoxData.price,
                alcohol: _ctx.productBoxData.alcohol,
                "show-volume-unit-text": true,
                "show-star": true
              }, null, 8 /* PROPS */, ["value", "alcohol"]))
            : _createCommentVNode("v-if", true)
        ]),
        _cache[13] || (_cache[13] = _createTextVNode()),
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_product_qty_and_cart_btn, {
            class: "product-box-campaign__buttons",
            "product-data": _ctx.productBoxData,
            "product-link": _ctx.productLink,
            state: _ctx.state,
            onAddToBasket: _ctx.addToBasket,
            onQuantityChange: _ctx.changeQuantity,
            onOnRequestClicked: _ctx.openOnRequestLightBox
          }, null, 8 /* PROPS */, ["product-data", "product-link", "state", "onAddToBasket", "onQuantityChange", "onOnRequestClicked"]),
          _cache[11] || (_cache[11] = _createTextVNode()),
          (_ctx.productBoxData.inBasket)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "product-box__status product-box__status--basket",
                href: _ctx.basketUrl
              }, _toDisplayString(_ctx.$t('ads.ads_top_info.article_in_basket')), 9 /* TEXT, PROPS */, _hoisted_32))
            : _createCommentVNode("v-if", true),
          _cache[12] || (_cache[12] = _createTextVNode()),
          (_ctx.productBoxData.showFoodSpecificationLink && !_ctx.hideCounterButton)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.foodSpecificationLink,
                class: "product-box__link",
                innerHTML: _ctx.$t('detail.product.characteristics')
              }, null, 8 /* PROPS */, _hoisted_33))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}